import { put, takeLeading } from 'redux-saga/effects';

import locationApi from 'api/locationApi';
import { LOGIN_TYPE, storageKey } from 'constants/index';
import { apiErrorHandler, showSuccess } from 'utils';

import {
  GET_LOCATION_LIST,
  EXPORT_LOCATION_LIST,

  DELETE_LOCATION,
  GET_ADVANCE_BOOKING_CHARTS,
  GET_STAY_NIGHTS_CHARTS,
  GET_BOOKING_STATUS_RATIO,
  GET_REVENUE_DISTRIBUTION_ACCOUNT_LEVELS,
} from './actionTypes';
import {
  actionGetLocationListSuccess,
  actionGetLocationListFailed,
  actionExportLocationListSuccess,
  actionExportLocationListFailed,
  actionDeleteLocationSuccess,
  actionDeleteLocationFailed,
  actionGetAdvanceBookingChartsSuccess,
  actionGetAdvanceBookingChartsFailed,
  actionGetStayNightsChartsSuccess,
  actionGetStayNightsChartsFailed,
  actionGetBookingStatusRatioSuccess,
  actionGetBookingStatusRatioFailed,
  actionGetRevenueDistributionAccountLevelsSuccess,
  actionGetRevenueDistributionAccountLevelsFailed,
} from './actions';

function* getLocationList({ payload }) {
  try {
    const loginType = localStorage.getItem(storageKey.LOGIN_TYPE);
    const response = loginType === LOGIN_TYPE.INTRANET
      ? yield locationApi.getIntranetLocationList(payload)
      : yield locationApi.getLocationList(payload);

    yield put(
      actionGetLocationListSuccess(response.payload),
    );
  } catch (error) {
    apiErrorHandler(error);

    yield put(actionGetLocationListFailed());
  }
}

function* exportLocationList({ payload }) {
  try {
    const response = yield locationApi.exportLocationList(payload);

    window.open(response.payload.downloadUrl, '_blank');

    yield put(actionExportLocationListSuccess());
  } catch (error) {
    apiErrorHandler(error);

    yield put(actionExportLocationListFailed());
  }
}

function* deleteLocation({ payload }) {
  const { callback } = payload;
  try {
    yield locationApi.deleteLocation(payload);

    yield put(actionDeleteLocationSuccess(payload));

    callback?.();
    showSuccess('Xóa chỗ nghỉ thành công');
  } catch (error) {
    apiErrorHandler(error);

    yield put(actionDeleteLocationFailed());
  }
}

function* getAdvanceBookingCharts({ payload }) {
  try {
    const response = yield locationApi.getAdvanceBookingCharts(payload);

    yield put(actionGetAdvanceBookingChartsSuccess(response.payload));
  } catch (error) {
    apiErrorHandler(error);

    yield put(actionGetAdvanceBookingChartsFailed());
  }
}

function* getStayNightsCharts({ payload }) {
  try {
    const response = yield locationApi.getStayNightsCharts(payload);

    yield put(actionGetStayNightsChartsSuccess(response.payload));
  } catch (error) {
    apiErrorHandler(error);

    yield put(actionGetStayNightsChartsFailed());
  }
}

function* getBookingStatusRatio({ payload }) {
  try {
    const response = yield locationApi.getBookingStatusRatio(payload);

    yield put(actionGetBookingStatusRatioSuccess(response.payload));
  } catch (error) {
    apiErrorHandler(error);

    yield put(actionGetBookingStatusRatioFailed());
  }
}

function* getRevenueDistributionAccountLevels({ payload }) {
  try {
    const response = yield locationApi.getRevenueDistributionAccountLevels(payload);

    yield put(actionGetRevenueDistributionAccountLevelsSuccess(response.payload));
  } catch (error) {
    apiErrorHandler(error);

    yield put(actionGetRevenueDistributionAccountLevelsFailed());
  }
}

export default function* locationSaga() {
  yield takeLeading(GET_LOCATION_LIST, getLocationList);
  yield takeLeading(EXPORT_LOCATION_LIST, exportLocationList);
  yield takeLeading(DELETE_LOCATION, deleteLocation);
  yield takeLeading(GET_ADVANCE_BOOKING_CHARTS, getAdvanceBookingCharts);
  yield takeLeading(GET_STAY_NIGHTS_CHARTS, getStayNightsCharts);
  yield takeLeading(GET_BOOKING_STATUS_RATIO, getBookingStatusRatio);
  yield takeLeading(GET_REVENUE_DISTRIBUTION_ACCOUNT_LEVELS, getRevenueDistributionAccountLevels);
}
